export default "__VITE_ASSET__0ff6320a__"